import { makeStyles } from '@material-ui/core'

const styles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    background: `linear-gradient(90deg, ${theme.palette.dai.light} 0%, ${theme.palette.background.default} 50%, ${theme.palette.dai.light} 100%)`,
    backgroundSize: '200% 100%',
    backgroundPosition: '0% 0%',
  },
  baseBox: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
  thumbsUpIcon: {
    '&:hover': {
      color: theme.palette.success.main,
    },
  },
  thumbsDownIcon: {
    '&:hover': {
      color: theme.palette.error.main,
    },
  },
}))

export default styles
